import type { components } from '@/generated/internal-api/openapi-types';

export type UserGroupRow = components['schemas']['UserGroupV1'];
export type UserGroupCreatePayload = components['schemas']['UserGroupCreateV1'];
export type UserGroupUpdatePayload = components['schemas']['UserGroupUpdateV1'];
export type UserGroupMembersUpdatePayload = components['schemas']['UserGroupMembersUpdateV1'];
export type UserGroupMembershipUpdatePayload = components['schemas']['UserGroupMembershipUpdateV1'];

export const USER_GROUP_NAME_MAX_LENGTH = 255;
export const USER_GROUP_DESCRIPTION_MAX_LENGTH = 500;

/**
 * Only active and pending users may hold group membership — a suspended account cannot sign in to
 * use what the group grants, and the API rejects it. Pending is allowed so a new starter can be
 * placed in a group before accepting their invitation.
 */
export const ELIGIBLE_MEMBER_STATUSES = ['active', 'pending'] as const;

/** Whether a user may hold group membership at all; the API rejects anyone else. */
export const isEligibleMember = (status: string): boolean =>
  ELIGIBLE_MEMBER_STATUSES.some((eligible) => eligible === status);

/** Group names shown in the Users table before the remainder collapses into a "+N" suffix. */
export const GROUPS_SHOWN_IN_CELL = 2;
